import React, { useEffect, useRef } from "react";

import ActionItemsList from "./ActionItemsList";

export default function Columns({
  columns,
  items,
  setActiveActionItem,
  setOpenAddActionItemModal,
  setOpenCompleteModal,
  isLoading = false,
}) {
  const scrollRef = useRef(null);

  const scrollToTop = () => {
    scrollRef.current.scroll({
      top: 0,
    });
  };
  useEffect(() => {
    if (scrollRef.current) {
      scrollToTop();
    }
  }, [columns]);
  return (
    <div className="flex" ref={scrollRef}>
      {columns &&
        columns.length > 0 &&
        columns.map((columnType) => {
          const itemType = columnType?.id.toString();
          return (
            <ActionItemsList
              key={"list_container_" + itemType}
              actionItemType={columnType?.actionFocus}
              itemsList={items[itemType]}
              setActiveActionItem={setActiveActionItem}
              setOpenAddActionItemModal={setOpenAddActionItemModal}
              setOpenCompleteModal={setOpenCompleteModal}
              isLoading={isLoading}
            />
          );
        })}
    </div>
  );
}
